import React, {useState} from "react";
import {
  SlTabGroup,
  SlTab,
  SlTabPanel,
} from "@shoelace-style/shoelace/dist/react";
import PlanSummary from "./PlanSummary";
import MonthwisePlan from "./MonthwisePlan";
import PenetrationVsNewspaper from "./PenetrationVsNewspaper";
import Conversion from "./Conversion";
import SalesTasks from "./SalesTasks";
import NationalPlanning from "./NationalPlanning";
import Buildup from './BuildupSheet'

function PlanningReports() {
  const [currentTab, setCurrentTab] = useState("planning");

  const handleTabChange = (tabName) => {
    setCurrentTab(tabName);
  };

  return (
    <>
      <h5>Yearly Reports</h5>
      <SlTabGroup>
        <SlTab slot="nav" panel="planning" onClick={()=>{handleTabChange('planning')}}>Planning</SlTab>
        <SlTab slot="nav" panel="buildup" onClick={()=>{handleTabChange('buildup')}}>BuildUp</SlTab>
        <SlTab slot="nav" onClick={()=>{handleTabChange('plan_summary')}} panel="plan_summary">Plan Summary</SlTab>
        <SlTab slot="nav" panel="monthwise_plan" onClick={()=>{handleTabChange('monthwise_plan')}}>Monthwise Plan</SlTab>
        <SlTab slot="nav" panel="penetration" onClick={()=>{handleTabChange('penetration')}}>Penetration vs Eenadu</SlTab>
        <SlTab slot="nav" panel="conversion" onClick={()=>{handleTabChange('conversion')}}>Conversion Progress</SlTab>
        <SlTab slot="nav" panel="keysalestasks" onClick={()=>{handleTabChange('keysalestasks')}}>Key Sales Takes</SlTab>
        <SlTabPanel name="planning">
          {currentTab === 'planning' && <NationalPlanning />}
        </SlTabPanel>
        <SlTabPanel name="buildup">
          {currentTab === 'buildup' && <Buildup />}
        </SlTabPanel>
        <SlTabPanel name="plan_summary">
            {currentTab === 'plan_summary' && <PlanSummary />}
        </SlTabPanel>
        <SlTabPanel name="monthwise_plan">
          {currentTab === 'monthwise_plan' && <MonthwisePlan />}
          </SlTabPanel>
        <SlTabPanel name="penetration">
          {currentTab === 'penetration' && <PenetrationVsNewspaper />}
          </SlTabPanel>
          <SlTabPanel name="conversion">
            {currentTab === 'conversion' && <Conversion />}
          </SlTabPanel>
        <SlTabPanel name="keysalestasks">
          {currentTab === 'keysalestasks' && <SalesTasks/>}
        </SlTabPanel>
      </SlTabGroup>
    </>
  );
}

export default PlanningReports;
